<div class="modal-dialogs-container">
  <div
    aza-rws-modal-dialog-overlay
    class="modal-dialog-overlay"
    (click)="onClose()"
  ></div>
  <div class="aza-section-content aza-section-colors modal-dialog-centered contact-search-modal-content">
    <div class="modal-dialog-title">
      {{ TRANSLATION_MAP.SEARCH_CONTACTS | translate }}
    </div>
    <section class="contact-search-list-container">
      @if (isLoading) {
        <div class="aza-padding">{{ TRANSLATION_MAP.LOADING | translate }}</div>
      } @else {
        <aza-rws-table
          class="multi-registration__table"
          [data$]="contactTableData$"
          [rowActionGetter]="contactTableRowActionGetter"
          (pageRequested)="onPageRequested($event)"
        >
          <div
            aza-rws-table-no-data-template
            class="multi-registration__table__empty aza-horizontal-stack aza-vertical-items-centered aza-flex-centered"
          >
            {{ TRANSLATION_MAP.NO_CONTACTS_AVAILABLE | translate }}
          </div>
        </aza-rws-table>
      }
    </section>
    <div class="aza-padding"></div>
    <div class="aza-horizontal-stack justify-self-end">
      <button class="aza-button" (click)="onClose()">
        {{ TRANSLATION_MAP.CLOSE | translate }}
      </button>
      <button
        class="aza-button"
        [disabled]="!hasContactSelection()"
        [class.disabled]="!hasContactSelection()"
        (click)="onSave()"
      >
        {{ TRANSLATION_MAP.SAVE | translate }}
      </button>
    </div>
  </div>
</div>
